<template>
    <TheModal class="sm" @close="close">
        <template v-slot:head>Онлайн-платеж</template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" @submit.prevent="submit">
            <ValidationProvider v-errors tag="div" vid="amount" class="form-group" rules="required|integer|min_value:10" :debounce="500">
                <label for="amount">Сумма платежа</label>
                <input id="amount" v-model="rechargeForm.amount" v-focus.select name="amount" type="number" class="form-control">

                <small class="form-text text-muted">Минимум <strong>10 р.</strong>, но не более <strong>30 000 р.</strong>, если платеж картой.</small>
            </ValidationProvider>

            <div class="my-4">
                <p>После нажатия кнопки <span class="font-italic">Оплатить онлайн</span> вы будете перенаправлены на сайт платежного сервиса, где сможете выбрать подходящий способ оплаты.</p>
                <p>Платеж зачисляется быстро, но может задержаться до нескольких минут.</p>
            </div>

            <button type="submit" class="btn btn-lg-192 btn-primary" :disabled="invalid">Оплатить онлайн</button>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import axios from 'axios'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { toastError } from '@/dialogs'

export default {
    components: {
        TheModal,

        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            rechargeForm: {
                amount: null
            }
        }
    },

    methods: {
        async submit() {
            if (!await this.$refs.obs.validate()) {
                return
            }

            try {
                let response = await axios.post('api/billing/recharge-url', this.rechargeForm)
                window.location.href = response.data
            } catch (error) {
                toastError('Ошибка')
            }
        },

        close() {
            this.$router.push({ name: 'profile' })
        }
    }
}
</script>
